<template>
  <v-main>
    <DetailsDialog ref="dialog" @reload="$refs.report.reload()" />

    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      :fetcher="fetchData"
      @rowClicked="selectRow"
      :selectable="true"
      @update:selected="(v) => (selectedIds = v)"
      :rememberLastClick="true"
    >
      <template v-slot:topbar-actions>
        <v-spacer />
        <v-btn color="primary" @click="newRow">
          Novo arquivo...
        </v-btn>
        <OMenuButton :menuOpts="menuOpts" />
      </template>
    </GenericReport>
  </v-main>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import DetailsDialog from './DetailsDialog.vue'
import { brDt } from 'oderon-commons/src/formatters.js'
import go from 'oderon-vue/models/go'

export default {
  pageTitle: 'Arquivos',
  components: {
    GenericReport,
    DetailsDialog
  },
  data() {
    return {
      reportSpec: {
        title: 'Arquivos',
        filters: [
          {
            type: 'Text',
            prefix: 'keywords',
            icon: 'mdi-magnify',
            size: 'md',
            debounceMs: 250
          },
          {
            type: 'Switch',
            prefix: 'includeInactive',
            label: 'Mostrar inativos',
            defVal: false
          }
        ]
      },
      adapterSpec: {
        defOrder: 'name asc',
        defCodes: ['id', 'projectName', 'filename', 'createdAt', 'updatedAt'],
        columns: [
          { t: 'ID|', w: 100, d: 'id', color: '#cccccc' },
          { t: 'Projeto', d: 'projectName' },
          { t: 'Filename', d: 'filename' },
          {
            t: 'Criado em|',
            d: 'createdAt',
            f: brDt,
            w: 250,
            selectable: true
          },
          {
            t: 'Atualizado em|',
            d: 'updatedAt',
            f: brDt,
            w: 250,
            selectable: true
          },
          {
            t: 'Desativado em|',
            d: 'deletedAt',
            f: brDt,
            w: 250,
            selectable: true
          }
        ]
      },

      // checkboxes marcados
      selectedIds: []
    }
  },
  computed: {
    menuOpts() {
      let len = this.selectedIds.length
      return [
        {
          text: 'Desativar...',
          onClick: () => this.confirmDelete(),
          disabled: len < 1
        },
        {
          text: 'Exportar CSV',
          onClick: () => this.$refs.report.downloadCsv()
        }
      ]
    }
  },
  methods: {
    async fetchData({ keywords, includeInactive, offset, limit, order } = {}) {
      let { count, rows } = await go.get('project-files', {
        keywords,
        includeInactive,
        offset,
        limit,
        order
      })
      return { count, rows }
    },

    async newRow() {
      let res = await this.$refs.dialog.open(null)
      if (res != null) {
        await this.$rootLoading(async () => {
          await this.save(res)
          await this.reload()
        })
      }
    },

    async selectRow({ row /*, isMiddle */ }) {
      // if (isMiddle) {
      //   window.open(`/#/setup/project-files/${row.id}`, '_blank')
      //   return
      // }
      let res = await this.$refs.dialog.open(row.id)
      if (res != null) {
        await this.$rootLoading(async () => {
          await this.save(res)
          await this.reload()
        })
      }
    },

    async reload() {
      return this.$refs.report.reload()
    },

    async save({ id, projectName, filename, contents }) {
      if (id == null) {
        await go.post('project-files', { projectName, filename, contents })
      } else {
        await go.put('project-files/' + id, { projectName, filename, contents })
      }
      await this.$snack('Salvo com sucesso')
    },

    async confirmDelete() {
      let res = await this.$confirmDeactivate({
        strings: 'arquivo;o',
        len: this.selectedIds.length
      })

      if (res) {
        this.$loading(async () => {
          for (let id of this.selectedIds) {
            await go.delete('api/project-files/' + id)
          }
          this.selectedIds = []
          this.$snack('Desativado(s) com sucesso')
          this.$refs.report.reload()
        })
      }
    }
  }
}
</script>

<style></style>
